<template>
    <section class="mobile-invoice-page">
        <van-nav-bar title="发票管理" left-arrow fixed placeholder z-index="100" safe-area-inset-top @click-left="goBack" />
        <main class="mobile-invoice-main">
            <section class="mobile-invoice-hero">
                <div><span>INVOICE CENTER</span><h1>发票记录</h1><p>查看发票申请进度和已完成的电子发票。</p></div>
                <van-icon name="bill-o" />
            </section>

            <div class="mobile-invoice-summary">
                <div><strong>{{ total }}</strong><span>全部发票</span></div>
                <div><strong>{{ completedCount }}</strong><span>已完成</span></div>
                <div><strong>{{ processingCount }}</strong><span>处理中</span></div>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多发票了" @load="loadInvoices">
                <div v-if="invoices.length" class="mobile-invoice-list">
                    <article v-for="invoice in invoices" :key="invoice.invoice_id" class="mobile-invoice-card">
                        <header>
                            <div class="mobile-invoice-card__icon"><van-icon name="description-o" /></div>
                            <div><span>{{ invoiceType(invoice.invoice_type) }}</span><h2>{{ invoice.header || '未填写发票抬头' }}</h2></div>
                            <van-tag round :type="invoiceStatus(invoice.status).type">{{ invoiceStatus(invoice.status).text }}</van-tag>
                        </header>
                        <div class="mobile-invoice-card__amount"><span>开票金额</span><strong>¥{{ formatPrice(invoice.price) }}</strong></div>
                        <div class="mobile-invoice-card__info">
                            <div><span>发票内容</span><strong>{{ invoice.content || '—' }}</strong></div>
                            <div><span>税号</span><strong>{{ invoice.no || '—' }}</strong></div>
                            <div><span>申请时间</span><strong>{{ formatTime(invoice.create_time) }}</strong></div>
                        </div>
                        <van-button v-if="Number(invoice.status) === 2 && invoice.download_link" block round plain type="info" icon="down" @click="downloadInvoice(invoice.download_link)">
                            下载电子发票
                        </van-button>
                    </article>
                </div>
                <van-empty v-else-if="!loading" image="search" description="暂无发票记录" />
            </van-list>
        </main>
    </section>
</template>

<script>
export default {
    name: 'MobileInvoiceManage',
    data() {
        return {invoices: [], total: 0, loading: false, finished: false, pageNumber: 0, pageSize: 10};
    },
    computed: {
        completedCount() { return this.invoices.filter(item => Number(item.status) === 2).length; },
        processingCount() { return this.invoices.filter(item => [1, 4].includes(Number(item.status))).length; },
    },
    methods: {
        goBack() { this.$router.push({path: '/user/profile/setting'}); },
        loadInvoices() {
            const nextPage = this.pageNumber + 1;
            this.$bbs.get('/bbs/invoice/piao', {
                params: {search: {}, sort: {}, total: this.total || 1, pageSize: this.pageSize, pageNumber: nextPage},
                need: {error: true},
            }).then(response => {
                const data = response.data || {};
                const list = Array.isArray(data.data) ? data.data : [];
                this.invoices = nextPage === 1 ? list : this.invoices.concat(list);
                this.total = Number(data.total) || this.invoices.length;
                this.pageNumber = Number(data.pageNumber) || nextPage;
                this.finished = !list.length || this.invoices.length >= this.total;
            }).catch(() => { this.finished = true; }).finally(() => { this.loading = false; });
        },
        invoiceType(value) { return value === 'zhuan' ? '增值税专用发票' : '增值税普通发票'; },
        invoiceStatus(value) {
            return {1: {text: '处理中', type: 'primary'}, 4: {text: '处理中', type: 'primary'}, 5: {text: '已关闭', type: 'default'}, 2: {text: '已完成', type: 'success'}}[Number(value)] || {text: '未知', type: 'default'};
        },
        formatPrice(value) { const number = Number(value); return Number.isFinite(number) ? number.toFixed(2) : '0.00'; },
        formatTime(value) {
            if (!value) return '—';
            if (typeof value === 'string' && !/^\d{10,13}$/.test(value)) return value;
            const number = Number(value); const date = new Date(number < 1000000000000 ? number * 1000 : number); const pad = item => String(item).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
        downloadInvoice(url) { window.open(url, '_blank'); },
    },
};
</script>

<style scoped lang="less">
.mobile-invoice-page { min-height: 100vh; color: #1d2937; background: #f4f7f6; }
.mobile-invoice-page /deep/ .van-nav-bar--fixed { z-index: 100 !important; background: #fff; box-shadow: 0 1px 8px rgba(24,34,53,.06); }
.mobile-invoice-page /deep/ .van-nav-bar__title { font-size: 17px; font-weight: 650; }
.mobile-invoice-main { padding: 12px 12px 30px; }
.mobile-invoice-hero { display: flex; overflow: hidden; min-height: 130px; padding: 21px 19px; align-items: center; justify-content: space-between; color: #fff; background: radial-gradient(circle at 92% 8%,rgba(107,215,173,.34),transparent 32%),linear-gradient(140deg,#123b3b,#21695c); border-radius: 18px; box-shadow: 0 10px 27px rgba(25,90,76,.17); }
.mobile-invoice-hero span { color: #84ddbf; font-size: 9px; font-weight: 800; letter-spacing: 1.3px; }
.mobile-invoice-hero h1 { margin: 6px 0 7px; font-size: 23px; }
.mobile-invoice-hero p { margin: 0; color: rgba(255,255,255,.7); font-size: 12px; }
.mobile-invoice-hero > .van-icon { color: rgba(255,255,255,.15); font-size: 67px; }
.mobile-invoice-summary { display: grid; margin-top: 13px; padding: 14px 8px; grid-template-columns: repeat(3,1fr); background: #fff; border: 1px solid #e1e9e6; border-radius: 14px; box-shadow: 0 5px 17px rgba(30,72,63,.05); }
.mobile-invoice-summary div { text-align: center; border-right: 1px solid #e7eeeb; }
.mobile-invoice-summary div:last-child { border-right: 0; }
.mobile-invoice-summary strong,.mobile-invoice-summary span { display: block; }
.mobile-invoice-summary strong { color: #1d6959; font-size: 19px; }
.mobile-invoice-summary span { margin-top: 3px; color: #91a09c; font-size: 10px; }
.mobile-invoice-list { display: grid; margin-top: 14px; gap: 12px; }
.mobile-invoice-card { padding: 17px 15px 15px; background: linear-gradient(155deg,#fff 55%,#f3fbf8); border: 1px solid #dfe9e6; border-top: 3px solid #2d9b7f; border-radius: 16px; box-shadow: 0 7px 22px rgba(26,79,67,.055); }
.mobile-invoice-card header { display: flex; align-items: center; gap: 10px; }
.mobile-invoice-card header > div:nth-child(2) { min-width: 0; flex: 1; }
.mobile-invoice-card header span { color: #69988c; font-size: 9px; font-weight: 750; }
.mobile-invoice-card header h2 { overflow: hidden; margin: 4px 0 0; font-size: 16px; text-overflow: ellipsis; white-space: nowrap; }
.mobile-invoice-card__icon { display: flex; width: 39px; height: 39px; flex: 0 0 39px; align-items: center; justify-content: center; color: #207862; font-size: 20px; background: linear-gradient(135deg,#d9f5ec,#83d6bd); border-radius: 12px; }
.mobile-invoice-card__amount { display: flex; margin-top: 15px; padding: 12px; align-items: center; justify-content: space-between; background: #f2f9f7; border-radius: 10px; }
.mobile-invoice-card__amount span { color: #79968f; font-size: 12px; }
.mobile-invoice-card__amount strong { color: #1d735e; font-size: 20px; }
.mobile-invoice-card__info { display: grid; padding: 13px 2px; gap: 9px; }
.mobile-invoice-card__info div { display: flex; min-width: 0; justify-content: space-between; gap: 15px; }
.mobile-invoice-card__info span { flex: none; color: #99a5a2; font-size: 11px; }
.mobile-invoice-card__info strong { overflow: hidden; color: #596b67; font-size: 12px; font-weight: 550; text-align: right; text-overflow: ellipsis; white-space: nowrap; }
.mobile-invoice-card /deep/ .van-button--info { color: #26826c; border-color: #70bba8; }
</style>
